import { ReactNode } from "react";
import { Tabs } from "../../components/TabSwitch/Tabs";
import BaseTopUpRequest from "../RaiseETopUpRequest/BaseTopUpRequest";

interface StockTransferProps {
  children?: ReactNode;
}

const StockTransfer = ({ children }: StockTransferProps) => {
  return (
    <BaseTopUpRequest
      showWalletSelection={true}
      showPaymentTypeSelection={false}
      defaultPaymentType="stock_transfer"
      useNestedDropdown={true}
    >
      {children}
    </BaseTopUpRequest>
  );
};

export default StockTransfer;
